module.exports = __webpack_public_path__ + "static/img/3-nei.40a4c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/3-nei.png
// module id = /tdV
// module chunks = 1